<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Allowance Type
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Allowance Types"
      text="Create Type"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col 
              cols="4"
              class="pb-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col 
              cols="4"
              class="pb-0"
            >
              <v-text-field
                v-model="rate"
                v-validate="'required|twoDecimalValue'"
                type="number"
                :error-messages="errors.collect('rate')"
                data-vv-name="rate"                
                label="Rate"
                value="1"
              />
            </v-col>
            <v-col 
              cols="4"
              class="pb-0"
            >
              <v-autocomplete
                v-model="unitOfMeasurement"
                v-validate="'required'"
                :rules="rules"
                :error-messages="errors.collect('unitOfMeasurement')"
                :items="unitOfMeasurements"
                data-vv-name="unitOfMeasurement"
                data-vv-as="unit of measurement"   
                item-text="name"
                item-value="id"
                label="Unit"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is EPF Contribute? </span>
              <v-radio-group
                v-model="isEpfContribute"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is EIS Contribute? </span>
              <v-radio-group
                v-model="isEisContribute"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is SOCSO Contribute? </span>
              <v-radio-group
                v-model="isSocsoContribute"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is Taxable? </span>
              <v-radio-group
                v-model="isPcb"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is Negative? </span>
              <v-radio-group
                v-model="isNegative"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is Additional Remuneration? </span>
              <v-radio-group
                v-model="isAdditionalRemuneration"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is Fixed? </span>
              <v-radio-group
                v-model="isFixed"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
            <v-col 
              cols="3"
              class="pb-0"
            >
              <span> Is Hrdf? </span>
              <v-radio-group
                v-model="isHrdf"
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="taxReliefCategory"
                :error-messages="errors.collect('taxReliefCategory')"
                :items="taxRelief"
                data-vv-name="id"
                data-vv-as="taxReliefCategory"   
                :item-text="item => '['+item.year+'] '+item.name"
                item-value="category"
                label="Tax Relief Type"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12"
              class="pb-0"
            >
              <v-textarea
                v-model="description"
                v-validate="'max:1000'"
                :rows="1"
                :error-messages="errors.collect('value')"
                data-vv-name="description"     
                data-vv-as="description"           
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import Big from 'big.js'
  export default {
    inject: ['$validator'],
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        rate: 1,
        unitOfMeasurements: [],
        unitOfMeasurement: 1,
        description: null,
        isNegative: 0,
        isEpfContribute: 0,
        isEisContribute: 0,
        isSocsoContribute: 0,
        isPcb: 0,
        isFixed: 0,
        isHrdf: 0,
        rules: [
          value => !!value || 'Required.',
        ],
        taxRelief: [],
        taxReliefCategory: null,
        isAdditionalRemuneration: 0,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
        this.loadUnitOfMeasurements()
        this.loadTaxRelief()
      },
    },
    mounted () {
      let _this = this

      this.$validator.extend('twoDecimalValue', {
        getMessage (field, args) {
          return 'Only 2 Decimals are allowed'
        },
        validate (value, args) {
          return _this.isValidNumbers(value)
        },
      })
    },
    methods: { 
      prepareFormData () {
        return {
          name: this.name,
          rate: this.rate,
          unit_of_measurement_id: this.unitOfMeasurement,
          is_negative: this.isNegative,
          is_epf_contribute: this.isEpfContribute,
          is_eis_contribute: this.isEisContribute,
          is_socso_contribute: this.isSocsoContribute,
          is_pcb: this.isPcb,
          tax_relief_category: this.taxReliefCategory,
          is_additional_remuneration: this.isAdditionalRemuneration,
          is_fixed: this.isFixed,
          is_hrdf: this.isHrdf,
          description: this.description,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
    
            this.$api.allowancePenaltyTypes().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Added new type' })
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
                this.setDialog(false) 
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.$validator.reset()
        this.name = null
        this.rate = 1
        this.unitOfMeasurement = 1
        this.isNegative = 0
        this.isEpfContribute = 0
        this.isEisContribute = 0
        this.isSocsoContribute = 0
        this.isPcb = 0
        this.allowancePenaltyTypeCategory = null
        this.isAdditionalRemuneration = 0
        this.isFixed = 0
        this.description = null
        this.taxReliefCategory = null
      },
      loadUnitOfMeasurements () {
        this.$api.unitOfMeasurements().list()
          .then((res) => {
            this.unitOfMeasurements = res.data
          })
          .catch(() => {})
      },
      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
      loadTaxRelief () {
        this.$api.taxRelief().list()
          .then(res => {
            this.taxRelief = res.data
          })
      },
    },
  }
</script>
